export const getBlogItemImageWrapperStyles = (displayType: string) => ({
	width: displayType === 'One Row' ? '100%' : { xs: '60%', md: '100%' },
	height: displayType === 'One Row' ? 'auto' : { xs: '60%', md: 'auto' },
});

export const getBlogItemImageStyles = {
	aspectRatio: '4/5',
};

export const blogItemBoxStyles = (displayType: string) => ({
	display: 'flex',
	flexDirection: displayType === 'One Row' ? 'column' : { sm: 'row', md: 'column' },
	width: '100%',
	height: '100%',
	backgroundColor: '#002044',
});

export const blogItemContentStyles = (displayType: string) => ({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	marginTop: displayType === 'One Row' ? '1.25rem' : { sm: '0', md: '1.25rem' },
	marginBottom: '2rem',
	marginLeft: displayType === 'Blog List Page' && { xs: '0.75rem', md: 0 }, // 12px -> 0.75rem
	gap: '.5rem',
});

export const blogFormattedDateStyles = {
	fontSize: '0.875rem', // 14px -> 0.875rem
	fontWeight: 700,
	lineHeight: '1rem', // 16px -> 1rem
	textTransform: 'uppercase',
	fontFamily: 'Messina Sans',
	letterSpacing: '0.1875rem', // 3px -> 0.1875rem
};

export const blogCategoryStyles = {
	fontSize: '0.875rem', // 14px -> 0.875rem
	fontWeight: 600,
	display: 'inline-block',
	alignSelf: 'flex-start',
	padding: '0.25rem 0.5rem', // 4px 8px -> 0.25rem 0.5rem
	textTransform: 'none',
	fontFamily: 'Messina Sans',
};
